import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Translator } from 'angular-translator';
import { MarketplaceService } from 'app/infrastructure/services/marketplace.service';
import { ProductFlowService } from 'app/infrastructure/services/productFlow.service';
import { OpcionCheckeable } from 'app/infrastructure/services/selects.service';


@Component({
  selector: 'marketplace-filter',
  templateUrl: './marketplace-filter.component.html',
  styleUrls: ['./marketplace-filter.component.scss'],
})
export class MarketplaceFilter implements OnInit {

  @Output() searchEvent: EventEmitter<string> = new EventEmitter();
  @Output() filtersEvent: EventEmitter<object> = new EventEmitter();
  @Input() onSubscription: boolean = false;
  @Input() disabled: any;
  subcriptionType: string;
  search: string = '';
  types: string[];
  organizations: OpcionCheckeable[];
  selectedTypes: string[] = [];
  selectedOrgs: string[] = [];
  collapsedType: boolean;
  collapsedOrg: boolean;

  constructor(
    public router: Router,
    protected aRoute: ActivatedRoute,
    public translate: Translator,
    public marketplaceService: MarketplaceService,
    private productFlowService: ProductFlowService
  ) {
    this.aRoute.data.subscribe((data: Params) => {
      this.subcriptionType = data.type;
    });
  }

  ngOnInit(){
    
    // Get Types
    this.marketplaceService.categoriesTypes.subscribe(response => this.types = response);
    // Get Organizations
    this.productFlowService.getCategories().then((x) => {
      this.organizations = x.map(cat => { return {id: cat.categoryId, descripcion: cat.descripcion, seleccionado: cat.selected}}) as OpcionCheckeable[];
    });
  }

  applyClientFilters(selectedType = null){
    if(selectedType != null){
      if(this.selectedTypes.includes(selectedType)) {
        const index = this.selectedTypes.findIndex(type => type === selectedType);
        this.selectedTypes.splice(index, 1);
      }
      else
        this.selectedTypes.push(selectedType);
    }
    
    this.filtersEvent.emit({
      search: this.search,
      types: this.selectedTypes,
      organizations : this.selectedOrgs
    });
  }

  collapseType(){
    this.collapsedType = !this.collapsedType;
  }

  collapseOrg(){
    this.collapsedOrg = !this.collapsedOrg;
  }
  
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/marketplace/marketplace-filter/marketplace-filter.component.ts